export default __webpack_public_path__ + "static/media/cat-1.2654fb1e.svg";